import React from "react";
import HeaderLogo from "./HeaderLogo";
import ProgressBar from "./ProgressBar";
import { useSelector, useDispatch } from 'react-redux';
import { changeLanguage } from "../store/settings/settingsSlice";

function Header() {
  const dispatch = useDispatch();
  const partnerName = useSelector((state) => state.partner.name);
  const logoImageData = useSelector((state) => state.partner.logo_image);
  const isLogoLoading = useSelector((state) => state.partner.is_logo_loading);
  const currentLanguage = useSelector((state) => state.settings.currentLanguage);

  return (
    <header>
      <div className="container mx-auto flex justify-between items-center p-2 sm:px-4 md:px-2 md:py-4">
        <div className="leading-none">
          <a href="/">
            <HeaderLogo partnerName={partnerName} imageData={logoImageData} isLoading={isLogoLoading} />
          </a>
        </div>
        <div>
          <div className="select w-52">
            <select value={currentLanguage} onChange={event => dispatch(changeLanguage(event.target.value))}>
              <option value="en">English</option>
              <option value="es">Español</option>
            </select>
          </div>
        </div>
      </div>
      <ProgressBar />
    </header>
  );
}

export default Header;